import { forwardRef, type Ref, type SVGProps } from "react";
const IconMenuOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27 17H5a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2m0-8H5a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2m0 16H5a1 1 0 0 1 0-2h22a1 1 0 0 1 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMenuOutlineSVG);
ForwardRef.displayName = "IconMenuOutline";
export { ForwardRef as IconMenuOutline };
